import React from 'react';
import { titleCase, get } from "@dex/bubl-helpers";
import StatsSetApi from './StatsSetApi';
import StatsSetActions from './Components/StatsSetActions';

let settings;

export default settings = {
    key: 'users/stats/sets',
    zone: 'users',
    path: '/users/stats/sets',
    title: "Stats Set",
    endpoint: StatsSetApi.endpoint,
    modelName: 'StatsSet',
    idKey: 'id',
    primaryKey: 'id',
    indexCaps: ["viewStatsSet"],
    viewCaps: ["viewStatsSet"],
    createCaps: ["createStatsSet"],
    indexTitle: (routeName, params, users) => {

        let title: string = settings.title;

        if (params && params.name) title = title + " / " + titleCase(params.name);

        return title;

    },
    indexTabs: (routeName, params, users) => {

        return [
            {
                label: "All",
                path: settings.path,
                caps: settings.indexCaps
            },
            {
                label: "Add New",
                path: settings.path + "/create",
                caps: settings.createCaps
            },
        ]

    },
    indexButtons: (routeName, params, users) => {

        return [
            {
                label: "Add New",
                path: settings.path + '/create',
                caps: settings.createCaps
            }
        ]

    },
    indexTabCounts: (routeName, params, dontation) => {

        return settings.endpoint + "/getCounts";

    },
    indexFetch: StatsSetApi.get,
    indexFetchParams: (routeName, params, users) => {

        const filters: any = { where: {}, include: ['group', 'owner', 'league'/* , 'season', 'team', 'player' */], order: ['created.date DESC'], limit: 10, skip: 0 };

        if (params && params.status) filters.where.status = { inq: [params.status] };

        return filters;

    },
    indexQuickSearch: (routeName, params, users) => {

        const fields = ['id'];

        return fields;

    },
    indexSearchFields: (routeName, params, users) => {

        const fields = [
            {
                label: "ID",
                key: "id",
                type: "text",
            },
            {
                label: "User",
                key: "ownerId",
                type: "relationship",
                model: "Users",
            },
            {
                label: "Group Name",
                key: "groupId",
                type: "relationship",
                model: "StatsGroup",
            },
        ];

        return fields;

    },

    indexColumns: (routeName, params, users) => {

        const columns = [
            {
                label: "ID",
                key: "this",
                format: "ModelLink",
            },
            {
                label: "User",
                key: "owner",
                format: "ModelLink"
            },
            {
                label: "Group Name / Player Profile",
                key: "group",
                format: "ModelLink",
            },
            {
                label: "Type",
                key: "type",
                format: 'titleCase'
            },
            {
                label: "Status",
                key: "status",
                format: 'titleCase'
            },
            {
                label: "Created Date",
                key: "created",
                format: "OnAndBy",
                sort: "created.date",
                alignEnd: true
            },
            {
                label: "Actions",
                key: "actions",
                alignEnd: true,
                render: (value, data) => {

                    return <StatsSetActions data={data} />;

                }
            }
        ];

        return columns;

    },
    singleFetch: StatsSetApi.getOne,
    singleFetchParams: (routeName, params, users, fetch) => {

        const filters = { include: ['group', 'owner', 'league'/* , 'season', 'team', 'player' */] };

        return filters;

    },
    singleTitle: (routeName, params, users, fetch) => {

        let title: string = "Loading...";

        const complete = get(fetch, 'complete');
        const error = get(fetch, 'error');
        const data = get(fetch, 'data');

        if (error) title = "Error";
        else if (data) title = data[settings.primaryKey];
        else if (complete && !data) title = "Not Found";

        return title;

    },
    singleTabs: (routeName, params, users, fetch) => {

        const path = settings.path + "/" + params.id;

        return [
            {
                label: "View",
                path: path + "/view"
            },
            {
                label: "Edit",
                path: path + "/edit"
            },
        ]

    },
};